import type {ReactNode} from 'react'
import React from 'react'
import {FullWidthCarousel} from '@/_new-code/products/flexible-web-toolkit/components/carousel/full-width-carousel'
import styles from './HeaderBlockWithCarousel.module.css'

interface HeaderBlockWithCarouselProps {
	className?: string
	children: ReactNode
}

export const HeaderBlockWithCarousel = ({
	className = '',
	children = null,
}: HeaderBlockWithCarouselProps): React.JSX.Element => {
	return (
		<div>
			<FullWidthCarousel
				className={`${className} ${styles.HeaderBlockCarousel}`}
			>
				{children}
			</FullWidthCarousel>
		</div>
	)
}
